<template>
  <q-page class="main-wrapper-page single-page" style="background-color: var(--q-accent)">
    <q-banner class="bg-blue q-mb-md text-white" style="min-height: 30px; border-radius: 4px"
      >Please, provide a reason to onboard POSTMAN access products for your digital service. It will be included in the
      Change Request justification.</q-banner
    >
    <section class="widget-section q-mb-lg">
      <EnvRegistration
        :registrationId="registrationId"
        :registrationData="registrationData"
        :envs="envs"
        mode="edit"
        :additionalSchemaProperties="additionalSchemaProperties"
        :additionalUiSchemaElements="additionalUiSchemaElements"
      />
      <ul class="details q-mt-lg" v-if="details">
        <li>
          <q-spinner v-if="!details && environments?.length" size="18px"></q-spinner>
          <b>Change Request:</b>
          <div class="q-ml-auto">
            <q-spinner v-if="!details && environments?.length" size="18px"></q-spinner>
            <a :href="details?.changeLink" target="_blank" v-else>{{ details?.changeNumber || 'n/a' }}</a>
          </div>
        </li>
      </ul>
    </section>
  </q-page>
</template>

<script>
import EnvRegistration from './EnvRegistration.vue';
import { getRegistration } from '@/pages/registrations/api/api';

export default {
  name: 'RegistrationPostman',
  components: {
    EnvRegistration,
  },
  props: {
    registrationId: {
      type: String,
    },
    registrationData: {
      type: Object,
    },
  },
  data() {
    return {
      additionalSchemaProperties: {
        reason: {
          type: 'string',
          minLength: 10,
        },
      },
      additionalUiSchemaElements: [
        {
          type: 'Control',
          label: 'Reason',
          scope: '#/properties/reason',
        },
      ],
      envs: ['PROD'],
      details: {},
      environments: [],
    };
  },
  async mounted() {
    this.loadData = false;
    try {
      const data = await getRegistration(this.registrationId, true, true);
      this.details = data && data.details ? data?.details[0] : undefined;
      this.environments = data.environments;
    } catch (error) {
      this.$notify('negative', 'Error', error.message);
    } finally {
      this.loadData = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.details {
  display: flex;
  flex-wrap: wrap;
  padding: 0;

  li {
    width: calc(33.333% - 10px);
    padding: 20px;
    border: 1px solid $grey-4;
    border-radius: 10px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    @media (max-width: $breakpoint-sm-max) {
      width: 100%;
    }
  }
}
</style>
